import { Box, Flex } from "@chakra-ui/react";
import { Navigate, Route, Routes } from "react-router-dom";
import { HomePage } from "../pages/HomePage";
import { ImportPage } from "../pages/Import/ImportPage";
import { ResidenceTypeListPage } from "../pages/ResidenceTypes/ResidenceTypeListPage";
import { ImportStatusPage } from "../pages/Import/ImportStatusPage";
import { ResidenceTypeDetailPage } from "../pages/ResidenceTypes/ResidenceTypeDetailPage";
import { Sidebar } from "../compositions/Sidebar";
import { ImportReportDetailPage } from "../pages/Import/ImportReportDetailPage";
import { CustomerListPage } from "../pages/Customers/CustomerListPage";
import { CustomerDetailPage } from "../pages/Customers/CustomerDetailPage";
import { ResidenceCategoryListPage } from "../pages/ResidenceCategories/ResidenceCategoryListPage";
import { ResidenceCategoryDetailPage } from "../pages/ResidenceCategories/ResidenceCategoryDetailPage";
import { RoofTypeListPage } from "../pages/RoofTypes/RoofTypeListPage";
import { RoofTypeDetailPage } from "../pages/RoofTypes/RoofTypeDetailPage";
import { SituationListPage } from "../pages/Situations/SituationListPage";
import { ScenarioListPage } from "../pages/Scenarios/ScenarioListPage";
import { SituationDetailPage } from "../pages/Situations/SituationDetailPage";

export function AuthenticatedLayout() {
  return (
    <Flex h="full" overflow="hidden" w="full">
      <Sidebar />
      <Box overflowY="auto" p={4} w="full">
        <Routes>
          <Route element={<HomePage />} index />

          <Route path="import">
            <Route element={<ImportPage />} index />
            <Route path=":importId">
              <Route element={<ImportStatusPage />} index />
              <Route element={<ImportReportDetailPage />} path="report" />
            </Route>
          </Route>

          <Route path="residence-types">
            <Route element={<ResidenceTypeListPage />} index />
            <Route
              element={<ResidenceTypeDetailPage />}
              path=":residenceTypeId"
            />
          </Route>

          <Route path="situations">
            <Route element={<SituationListPage />} index />
            <Route element={<SituationDetailPage />} path=":situationId" />
          </Route>

          <Route path="scenarios">
            <Route element={<ScenarioListPage />} index />
            {/* <Route element={<ScenarioDetailPage />} path=":scenarioId" /> */}
          </Route>

          <Route path="customers">
            <Route element={<CustomerListPage />} index />
            <Route element={<CustomerDetailPage />} path=":customerId" />
          </Route>

          <Route path="residence-categories">
            <Route element={<ResidenceCategoryListPage />} index />
            <Route
              element={<ResidenceCategoryDetailPage />}
              path=":residenceCategoryId"
            />
          </Route>

          <Route path="roof-types">
            <Route element={<RoofTypeListPage />} index />
            <Route element={<RoofTypeDetailPage />} path=":roofTypeId" />
          </Route>

          <Route element={<Navigate replace to="/" />} path="*" />
        </Routes>
      </Box>
    </Flex>
  );
}
